import React, { useState, useEffect } from 'react';
import { gql } from 'apollo-boost';
import { useMutation } from '@apollo/react-hooks';
import TextInput from '../Form/TextInput/TextInput';
import Section from './Section';
import OTPModal from './OTPModal';
import {getEmailValidationRules} from "../../utils/inputValidations";
import withFeatureFlags from "../FeatureFlags/withFeatureFlags";

/** @import {EmailAddressProps} from './EmailAddressTypes' */
/** @import {WithFeatureFlagsProps} from '../FeatureFlags/FeatureFlagsTypes' */

const SEND_OTP = gql`
  mutation SendLoggedInOtp($request : SendOtpRequestType!){
    sendLoggedInOtp(request:$request) {
      success
      verificationToken
    }
  }  
`;

const UPDATE_EMAIL = gql`
  mutation updateEmailWithVerification($request : UpdateEmailWithVerificationRequestType!){
    updateEmailWithVerification(request:$request) {
      success
    }
  }  
`;

function EmailAddress(/** @type {EmailAddressProps & WithFeatureFlagsProps} */ { profile, onSave, featureEnabled }) {
  const [editing, setEditing] = useState(false);
  const [email, setEmail] = useState(profile.email);
  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [sendOtp] = useMutation(SEND_OTP);
  const [updateEmailWithVerification] = useMutation(UPDATE_EMAIL);
  const [verificationToken, setVerificationToken] = useState('');
  const [showValidation, setShowValidation] = useState(false);
  const [validationErrorLabel, setValidationErrorLabel] = useState("");

  const cancelEditing = () => {
    setEmail(profile.email);
    setShowValidation(false)
  };

  const startEditing = (/** @type {boolean} */ editing) => {
    if (editing) {
      setEmail('');
    }

    setEditing(editing);
  }

  const setEmailChange = (/** @type {string} */ email) => {
    setEmail(email);
    setShowValidation(false);
  }

  const approveEditing = async () => {
    setOtpModalOpen(true);

    var result = await sendOtp({
      variables: {
        request: {}
      }
    });

    if (result.data.sendLoggedInOtp.verificationToken) {
      setVerificationToken(result.data.sendLoggedInOtp.verificationToken);
    }
  };

  const onModalCancel = () => {
    setOtpModalOpen(false);
    cancelEditing();
  };

  const onModalComplete = () => {
    setOtpModalOpen(false);
    onSave && onSave({ email });
  };

  const customVerification = async (/** @type {string} */ otp, /** @type {string} */ mode) => {
    var result = await updateEmailWithVerification({
      variables: {
        request: {
          email: email,
          verifyOtp: {
            passCode: otp,
            verificationToken: verificationToken,
            mode: mode
          }
        }
      }
    });

    return {
      success: result.data.updateEmailWithVerification.success,
      data: {approved: true}
    }
  }

  const emailValidation = () => {
    if (email) {
      const rules = getEmailValidationRules(featureEnabled('BlockInvestecStaffEmail'));
      var isValid = false
      
       rules.forEach((r) => {
        if (!r.test(email)) {
          setShowValidation(true)
          setValidationErrorLabel(r.label)
          isValid = false
          return
        }
         isValid = true
        return
      })
      return isValid
    }
    return false
  };

  useEffect(() => {
    setEmail(profile.email);
  }, [profile.email]);


  return (
    <Section title="Email" editing={editing} setEditing={startEditing} onCancel={cancelEditing} onSave={approveEditing} validation={emailValidation} valid={true}>
      <TextInput value={email} onChange={setEmailChange} disabled={!editing} hasError={showValidation} />
      {otpModalOpen && <OTPModal 
        title="Update email address"
        successMessage="Your email address has been updated. Please use this to log in going forward."
        mobileNumber={profile.mobileNumber} 
        onClose={onModalCancel} 
        onComplete={onModalComplete} 
        analyticsRegion={"my profile"}
        analyticsAction={"Email address change"} 
        verificationToken={verificationToken}
        customVerification={customVerification} />}
        <div className={showValidation ? "login__error" : "login__error login__error--hide"}>
          <span className="login__error--wrap">{validationErrorLabel}</span>
        </div>
    </Section>
  );
};

export default withFeatureFlags(EmailAddress);